module.exports = __webpack_public_path__ + "static/media/Dog-vs-Cat.124647da.jpg";